export default "__VITE_ASSET__B7oVEh13__"